class QiscusTextParser {
  constructor() {
    // check the extension
    this.imageLink = /(\b(https?|ftp|file):\/\/\S+\/([A-Z0-9\-\.\+\_%]+)(\.png|\.jpg|\.gif|\.jpeg|\.jpeg\-large)[-A-Z0-9+&@#\/\?;%=~_|$?!:,.]*)/gi;
    this.youtubeLink = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*([\S]*)/gi;
    this.googleIframe = /\<p\>&lt;iframe src=(&quot;|"|')(https?)(:\/\/(www.)?google\.com\/maps\/embed\?(\S)*)(&quot;|'|")(.)*&lt;\/iframe\&gt;\<\/p\>/gi;
    this.linkPattern = /((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)[-A-Z0-9+&@#\/%=~_|$?!:;,.\|\(\[\{\}\]\)\`\^]*[A-Z0-9+&@#\/%=~_|$])(?!([^<]+)?>)/gi;
    this.enhLinkPattern = /((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)[-A-Z0-9+&@#\/%=~_|$?!:;,.\|\(\[\{\}\]\`\^]*[A-Z0-9+&@#\/%=~_|$])(?!([^<]+)?>)/gi;
    this.BitbucketNotif = /#bitbucket(\r\n|\r|\n)(([a-z0-9]|\-|_)*)( push to )((\S)*)( on branch )((\S)*)( with commit : )((\S| |\r\n|\r|\n|\t)*)( )\[([0-9a-z])*\] \. link to commit : ((\S)*)\/([a-z0-9]*)/i;
    this.DropboxImg = /https?:\/\/(www\.dropbox)\.com\/((\S)*)\.(jpeg|jpg|gif|png)\?(dl\=(0|1))/gi;
    this.DropboxFile = /https?:\/\/(www\.dropbox)\.com\/((\S)*)\/((\S)*)\.(\S*)\?(dl\=(0|1))/gi;
  }

  replaceTag(tag) {
    const tagsToReplace = {
      '<': '&lt;',
      '>': '&gt;',
    };
    return tagsToReplace[tag] || tag;
  }

  safeTagsReplace(str) {
    if (!str) return str;
    return str.replace(/[<>]/g, this.replaceTag);
  }

  parse(text) {
    let renderedText = this.safeTagsReplace(text);
    if (!renderedText) return renderedText;
    renderedText = renderedText.replace(/&L/g, '&amp;L')
      .replace(/&G/g, '&amp;G')
      .replace(/&gt(?!;)/g, '&amp;gt')
      .replace(/&lt(?!;)/g, '&amp;lt');
    renderedText = renderedText.replace(this.googleIframe, '<iframe style="border:1px solid #dedede;" width="455" height="320" src="https$3" frameborder="0"></iframe><br/>');
    renderedText = renderedText.replace(this.youtubeLink, '<iframe style="border:1px solid #dedede;" width="455" height="320" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>');
    // .replace(this.imageLink,"<span class='imageloader loaded'><img src='$1' alt='$3$4' /></span>")
    renderedText = this.transformNonHttpUrl(renderedText);
    renderedText = this.parseOtpButton(renderedText);
    renderedText = renderedText.replace(this.linkPattern, '<a href="$1" target="_blank">$1</a>');
    return renderedText;
  }

  parseSpecial(text) {
    let renderedText = this.safeTagsReplace(text);
    renderedText = renderedText.replace(this.googleIframe, '<iframe style="border:1px solid #dedede;" width="455" height="320" src="https$3" frameborder="0"></iframe><br/>');
    renderedText = renderedText.replace(this.youtubeLink, '<iframe style="border:1px solid #dedede;" width="455" height="320" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>');
    renderedText = this.transformNonHttpUrl(renderedText);
    renderedText = renderedText.replace(this.linkPattern, '<a href="$1" target="_blank">$1</a>');
    return renderedText;
  }

  // used for email render
  sanitizeHTML(input) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');

    const dangerousTags = ['script', 'iframe', 'object', 'embed'];
    const exceptionsIframe = ':not([data-safe="true"])';
    dangerousTags.forEach((tag) => {
      const tagFil = tag === 'iframe' ? tag + exceptionsIframe : tag;
      const elements = doc.querySelectorAll(tagFil);
      elements.forEach((el) => {
        const stringEl = el.outerHTML;
        const safehtml = document.createElement('div');
        safehtml.innerText = stringEl;
        el.replaceWith(safehtml);
      });
    });

    const dangerousAttributes = ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange'];
    doc.body.querySelectorAll('*').forEach((el) => {
      dangerousAttributes.forEach((attr) => {
        if (el.hasAttribute(attr)) {
          el.removeAttribute(attr);
        }
      });
    });

    // Return sanitized HTML as a string
    return doc.body.innerHTML;
  }

  parseForEmail(text) {
    let renderedText = this.safeTagsReplace(text);
    renderedText = renderedText.replace(this.googleIframe, '<iframe data-safe="true" style="border:1px solid #dedede;" width="455" height="320" src="https$3" frameborder="0"></iframe><br/>');
    renderedText = renderedText.replace(this.youtubeLink, '<iframe data-safe="true" style="border:1px solid #dedede;" width="455" height="320" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>');
    renderedText = renderedText.replace(/&L/g, '&amp;L')
      .replace(/&G/g, '&amp;G')
      .replace(/&gt(?!;)/g, '&amp;gt')
      .replace(/&lt(?!;)/g, '&amp;lt');
    renderedText = renderedText
      .replace(/&amp;lt;/g, '<')
      .replace(/&amp;gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
    renderedText = this.transformNonHttpUrl(renderedText, this.enhLinkPattern);
    renderedText = renderedText.replace(this.enhLinkPattern, '<a href="$1" target="_blank">$1</a>');
    return this.sanitizeHTML(renderedText);
  }

  transformNonHttpUrl(text, customRegex = null) {
    let transformedText = text;
    const httpUrls = transformedText.match(customRegex || this.linkPattern);
    if (!httpUrls) return transformedText;
    httpUrls.forEach((txt) => {
      const httpUrl = (txt.substr(0, 4) === 'http') ? txt : `https://${txt}`;
      transformedText = transformedText.replaceAll(txt, httpUrl).replaceAll('https://https://', 'https://');
    });
    return transformedText;
  }

  parseOtpButton(text) {
    const waOtpURL = 'https://www.whatsapp.com/otp/code/';
    const isWaOTP = text.includes(waOtpURL);

    if (!isWaOTP) return text;

    let newText = text;
    const splitText = text.split(' ');
    const findIdxOtp = splitText.findIndex(txt => txt.includes(waOtpURL));

    if (findIdxOtp >= 0) {
      splitText[findIdxOtp] = 'Button';
      if (splitText[findIdxOtp + 1]) splitText[findIdxOtp + 1] = '';
      if (splitText[findIdxOtp + 2]) splitText[findIdxOtp + 2] = '';

      newText = splitText.join(' ');
    }

    return newText;
  }
}


module.exports = new QiscusTextParser();



// WEBPACK FOOTER //
// ./src/lib/textparser.js